import {
  client,
  SiteGroupsControllerListSummariesData,
  SiteGroupSummaryDto,
} from "@/client";
import { isDefined } from "@/lib/utils";
import { createTableContext } from "@/components/custom/data-table/data-table-context";
import { formatSiteGroupIdsChip } from "@/components/custom/data-table/filter-chip-lookups";
import { useColumns } from "./-site-groups-columns";

export const SiteGroupsTableContext = createTableContext<
  SiteGroupSummaryDto,
  SiteGroupsControllerListSummariesData
>({
  queryArgument: () => ({ page: 1, limit: 10 }),
  getRowId: (row) => {
    if (isDefined(row?.id)) {
      return `${row.id}`;
    }
    console.warn("undefined row.id", row);
    return ``;
  },
  queryCreator: (params) =>
    client.siteGroups.listSummaries.asQueryOptions(params),
  columns: useColumns,
  searchField: "name" as const,
  searchLabel: "Site Group Name",
  defaultFilters: {
    name: undefined,
    siteGroupIds: undefined,
  },
  filterBreadcrumbs: {
    formatters: {
      siteGroupIds: formatSiteGroupIdsChip,
    },
  },
});
